import React, { useEffect } from "react";
import { Menu, Checkbox, Collapse} from "antd";
import { useState } from "react";
import "./SearchDropdown.scss";
import Input from "../common/Input";
import search_icon from "../../svg/search_icon.svg";
import { createOtherSpecialization } from "../../store/apiCalls/profileDetails";
import { useDispatch } from "react-redux";
import OtherSubject from "../OtherSubject/OtherSubject";

const SearchDropdownProfile = (props) => {
  const {
    options,
    index,
    onChange,
    name,
    selectedValue,
    placeholder,
    label,
    labelClass,
    disabled,
    subjectId
  } = props;
  const dispatch = useDispatch();
  const [showSubject, setShowSubject] = useState(false);
  const [other, setOther] = useState({show: false, specialization: '', disabled: true});
  const [dropOptions, setDropOptions] = useState(Array.isArray(options) ? options : []);
  const [search, setSearch] = useState("");
  const [activeKey,setActiveKey] = useState('0');
  useEffect(() => {
    if (Array.isArray(options)) {
      setDropOptions(options);
    }
    // eslint-disable-next-line
  }, [options]);
  const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };

  const handleAddOthers = async () => {
    if(other.specialization && !other.disabled) {
      const queryParams = {
        data: {
          specialization: other.specialization,
          specializationId: other._id ? other._id : ""
        },
        headers
      };
      dispatch({ type: 'SET_LOADER', payload: true});
      const addResp = await createOtherSpecialization(queryParams);
      dispatch({ type: 'SET_LOADER', payload: false});
      if(addResp.data?.success) {
        setOther({show: false, specialization: '', disabled: true})
        props.handleOtherOption(addResp.data?.data)
      }
    } else if(other.disabled) {
      setOther({...other, disabled: false})
    }
  }

  const handleOptionSelect = (value, index) => {
    if(value.label === "Other Subject (choose this option to register your subject)" && selectedValue.length < 3) {
      setOther({...other, show: true, disabled: false})
      setShowSubject(true);
    } else {
      onChange({target: {value, name, checked: selectedValue?.includes(value?.value)}},index)
    }
    setActiveKey(null)
  }
  const onSearchChange = (e) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      let filterActivity = dropOptions.filter((ac) => {
        return ac?.label.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setDropOptions(filterActivity);
    } else {
      setDropOptions(options);
    }
  };
  
  const optionMenu = (
    <>
      <div>
        <div className="search-dropdown">
          <Input
            placeholder="Search"
            preIconClass={!search && search_icon}
            value={search}
            className={
              search
                ? "form-control active-input search-result"
                : "form-control grey-input with_icon"
            }
            handleChange={(e) => onSearchChange(e)}
          />
        </div>
        {selectedValue?.length > 0 && (
          <>
            Selected {name}s
            <Checkbox.Group>
              {options?.filter(opt => selectedValue?.includes(opt?.value)).map((exp, i) => (
                <Menu key={i}>
                  <Menu.Item onClick={(e) => handleOptionSelect(exp, index)}>
                    <input
                      type="checkbox"
                      key={i}
                      name={name}
                      id={name}
                      checked={selectedValue?.includes(exp?.value)}
                    />
                    {exp?.label}
                  </Menu.Item>
                </Menu>
              ))}
            </Checkbox.Group>
            <br />
          </>
        )}
        {dropOptions === options ? `Polular ${name}s` : `Searched ${name}s`}
        <Checkbox.Group>
          {dropOptions?.map((exp, i) => {
            if (!selectedValue?.includes(exp?.value))
              return (
                <Menu key={i}>
                  <Menu.Item className="menuStyle" onClick={() => handleOptionSelect(exp, index)}>
                    <input
                      type="checkbox"
                      key={i}
                      name={name}
                      id={name}
                      checked={selectedValue?.includes(exp?.value)}
                    />
                    {exp?.label}
                  </Menu.Item>
                </Menu>
              );
            else {
              return null;
            }
          })}
        </Checkbox.Group>
      </div>
    </>
  );
  return (
    <>
      <div className=""
        style={disabled ? { pointerEvents: "none", cursor: "pointer", opacity: "0.4" } : {}}
      >
        <label className={labelClass}>{label}<small className="input-required">*</small></label>
        <div
          className="filter-heading activity-filter-txt"
        >
          <Collapse onChange={(e) => setActiveKey(activeKey === "1" ? null : "1")} activeKey={activeKey} expandIconPosition="right" className={selectedValue?.length !== 0 ? "value-fill" : "value"}>
            <Collapse.Panel  header={`${selectedValue?.length === 0 ? placeholder: `${dropOptions?.filter(opt => selectedValue?.includes(opt?.value))[0]?.label} ${dropOptions?.filter(opt => selectedValue?.includes(opt?.value)).length > 1 ? `+ ${dropOptions.filter(opt => selectedValue?.includes(opt?.value)).length - 1}`: ''}`}`} key={"1"} >
              <p>{optionMenu}</p>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>
      {other.show && (
        <OtherSubject showSubject={showSubject} setShowSubject={setShowSubject} props={props} other={other} setOther={setOther} subjectId={subjectId} subjectType={"myProfile"} />
      )}
    </>
  );
};
export default SearchDropdownProfile;
